import React from 'react';

function FileCSV(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M16.7759 10.2015V8.95113H7.26548V10.2015H16.7759ZM7.26548 11.4515H9.49917V13.9515H7.26548V11.4515ZM6.01565 8.74312C6.01565 8.16795 6.48213 7.70146 7.05731 7.70146H16.9844C17.5596 7.70146 18.0261 8.16795 18.0261 8.74312V17.9098C18.0261 18.485 17.5596 18.9515 16.9844 18.9515H7.05731C6.48213 18.9515 6.01565 18.485 6.01565 17.9098V8.74312ZM16.7759 11.4515V13.9515H10.7492V11.4515H16.7759ZM10.7492 15.2015H16.7759V17.7011H10.7492V15.2015ZM9.49917 15.2015V17.7011H7.26548V15.2015H9.49917Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.0579 3.42286C16.9457 3.31341 16.7893 3.24854 16.625 3.24854H4.875C4.53018 3.24854 4.25 3.52871 4.25 3.87354V20.1235C4.25 20.4684 4.53018 20.7485 4.875 20.7485H19.125C19.4698 20.7485 19.75 20.4684 19.75 20.1235V6.27604C19.75 6.10786 19.6823 5.94732 19.5637 5.83097L19.5618 5.82911L17.0579 3.42286ZM20.4332 4.93296C20.7957 5.28544 21 5.77031 21 6.27604V20.1235C21 21.1587 20.1602 21.9985 19.125 21.9985H4.875C3.83982 21.9985 3 21.1587 3 20.1235V3.87354C3 2.83836 3.83982 1.99854 4.875 1.99854H16.625C17.1139 1.99854 17.5838 2.18973 17.9306 2.52789L20.4332 4.93296Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default FileCSV;
